import { JoyStep } from '@templates/Onboarding'

export const ONBOARDING_TITLE = 'Расскажем, как создать итоговое тестирование'

const STEP_TITLE = 'Создание итогового тестирования'

export const ONBOARDING_STEPS: JoyStep[] = [
  {
    target: '#final-test-method-manual',
    title: STEP_TITLE,
    content:
      'Вы сможете вручную заполнить список вопросов и ответов, параметры тестирования',
  },
  {
    target: '#final-test-method-xls',
    title: STEP_TITLE,
    content:
      'Вы сможете загрузить список вопросов из шаблона xls и вручную указать параметры тестирования',
  },
  {
    target: '#final-test-method-scorm',
    title: STEP_TITLE,
    content:
      'Вы сможете загрузить итоговое тестирование в формате SCORM. Тестирование должно быть собрано через инструмент iSpring. Параметры тестирования задаются внутри SCORM',
  },
  {
    target: '#final-test-submit-button',
    title: 'Для перехода к следующему шагу, выберите способ и нажмите кнопку «Добавить»',
    content: '',
  },
]
